import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferLabel: Record<OfferKindEnum, string> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% de réduction dès {{minSpendValue}}',
  [OfferKindEnum.PercentageOffByProducts]: 'Économisez {{percentageAmount}}% sur les articles sélectionnés',
  [OfferKindEnum.AmountOffByProducts]: 'Économisez {{amount}} sur les articles sélectionnés',
  [OfferKindEnum.AmountOffByMinSpendValue]: 'Économisez {{amount}} dès {{minSpendValue}}',
  [OfferKindEnum.Bogo]: "2 pour le prix d'1 – Aujourd'hui seulement",
  [OfferKindEnum.BogoHalfPrice]: '1 acheté, 1 à moitié prix',
  [OfferKindEnum.FreeItemByProducts]: "Aujourd'hui : obtenez votre article gratuit !",
  [OfferKindEnum.FreeItemByMinSpendValue]: "Aujourd'hui : article gratuit dès un certain montant !",
};

export default OfferLabel;
